import { VStack } from '@/package';

import DeploymentList from './DeploymentList';
import DeploymentListPagination from './DeploymentListPagination';

const DeploymentPageContent = () => {
  return (
    <VStack className="h-full">
      <DeploymentList />
      <DeploymentListPagination />
    </VStack>
  );
};

export default DeploymentPageContent;
